export default [
    {
        path: 'jornada',
        component: () => import(
            '@/views/transporte-paciente/jornada/Index'
        ),
        redirect: 'jornada/list',
        children: [
            {
                name: 'transporte-paciente-jornada-list',
                path: 'list',
                component: () => import(
                    '@/views/transporte-paciente/jornada/List'
                ),
            },
            {
                name: 'transporte-paciente-jornada-create',
                path: 'create',
                component: () => import(
                    '@/views/transporte-paciente/jornada/Form'
                ),
            },
            {
                name: 'transporte-paciente-jornada-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/transporte-paciente/jornada/Form'
                ),
            },
        ],
    },
]